import { Loader2 } from "lucide-react";

/**
 * ローディングスピナー付き送信ボタン
 */
export const LoadingButton: React.FC<{
  loading: boolean;
  loadingMessage?: string;
  label: string;
  type?: "submit" | "button";
  disabled?: boolean;
  onClick?: () => void;
  icon?: React.ReactNode;
}> = ({
  loading,
  loadingMessage = "処理中...",
  label,
  type = "submit",
  disabled,
  onClick,
  icon,
}) => (
  <button
    type={type}
    className="w-full bg-primary hover:bg-primary-dark text-white py-4 rounded-2xl text-xl font-bold transition-colors flex justify-center items-center"
    disabled={disabled ?? loading}
    onClick={onClick}
  >
    {loading ? (
      <div className="flex justify-center items-center text-gray-200">
        <Loader2 className="animate-spin" />
        <span className="ml-2">{loadingMessage}</span>
      </div>
    ) : (
      <>
        {icon && <span className="mr-2">{icon}</span>}
        {label}
      </>
    )}
  </button>
);
